const { default: axiosIns } = require('@/libs/axios')

const accountpropertytargetingsservice = {

  async getLists(filter) {
    const { skip, take } = filter
    return axiosIns.get('/admin/accountpropertytargetings/accountpropertytargetingslists', {
      params: {
        skip,
        take,
      },
    })
      .then(response => response.data)
  },
  async createProperty(property) {
    return axiosIns.post('/admin/accountpropertytargetings', property)
      .then(response => response.data)
  },
  async deleteProperty(property) {
    return axiosIns.delete(`/admin/accountpropertytargetings/${property.propertyId}`, {
      data: {
        ...property,
      },
    })
      .then(response => response.data)
  },
}
export default accountpropertytargetingsservice
